import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { LoanActionsStore } from '../stores/loanActionsStore';

export const useLoanActionsStore = () =>
  useContext<{
    loanActionsStore: LoanActionsStore;
  }>(StoreContext);